// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tgfFunctions } from "../../framework/tgfFunctions";
import { PhysicsSettings } from "../../settings/PhysicsSettings";
import { s_birdChuck_speed } from "../AssetDefinitions/SpineDefinitions";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectYellow(def, uid, x, y, angle, container) {
    BirdObjectYellow.uber.constructor.call(this, def, uid, x, y, angle, container);
}
tgfFunctions.inherit(BirdObjectYellow, BirdObjectDefault);
BirdObjectYellow.prototype.activateSpecialPower = function () {
    if (this.canUsePower && !this.firstContact) {
        this.playSound(this.soundStates.ABILITY, this.definition.sounds);
        this.canUsePower = false;
        if (this.specialAbilityEffect) {
            this.specialAbilityEffect.setScale(this.effectScale * 0.7);
            this.specialAbilityEffect.setAnimation("chuck_speed");
            this.container.addChild(this.specialAbilityEffect);
        }
        this.speedUp(PhysicsSettings.yellowBirdForce);
        return true;
    }
    return false;
};
BirdObjectYellow.prototype.step = function (timePassed) {
    BirdObjectYellow.uber.step.call(this, timePassed);
    if (this.firstContact) {
        if (this.specialAbilityEffect) {
            this.container.removeChild(this.specialAbilityEffect);
            this.specialAbilityEffect.free();
            this.specialAbilityEffect = undefined;
        }
    }
    if (this.specialAbilityEffect) {
        this.specialAbilityEffect.setPosition(this.x, this.y);
        this.specialAbilityEffect.setRotation(this.animationAngle + this.angle);
    }
};
BirdObjectYellow.prototype.spineInit = function () {
    "use strict";
    this.specialAbilityEffect = s_birdChuck_speed.clone();
};
